import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';

export const Industries = () => {
  const industries = [
    {
      name: 'Pool Builders',
      description: 'Connect with homeowners ready to build their dream pools.',
      image: 'https://images.unsplash.com/photo-1694782174671-279cb163ddb8?crop=entropy&cs=srgb&fm=jpg&q=85&w=600',
    },
    {
      name: 'Kitchen Remodeling',
      description: 'Qualified leads for complete kitchen transformations.',
      image: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?crop=entropy&cs=srgb&fm=jpg&q=85&w=600',
    },
    {
      name: 'Bathroom Remodeling',
      description: 'Appointments with homeowners seeking bathroom upgrades.',
      image: 'https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?crop=entropy&cs=srgb&fm=jpg&q=85&w=600',
    },
    {
      name: 'Roofing',
      description: 'Connect with property owners needing roof repairs or replacements.',
      image: 'https://images.unsplash.com/photo-1726589004565-bedfba94d3a2?crop=entropy&cs=srgb&fm=jpg&q=85&w=600',
    },
    {
      name: 'HVAC',
      description: 'Service calls from homeowners needing heating and cooling solutions.',
      image: 'https://images.pexels.com/photos/5463581/pexels-photo-5463581.jpeg?auto=compress&cs=tinysrgb&w=600',
    },
    {
      name: 'Backyard Renovations',
      description: 'Leads for outdoor living spaces and landscaping projects.',
      image: 'https://images.unsplash.com/photo-1558904541-efa843a96f01?crop=entropy&cs=srgb&fm=jpg&q=85&w=600',
    },
    {
      name: 'Tile & Flooring',
      description: 'Appointments for flooring installations and replacements.',
      image: 'https://images.unsplash.com/photo-1615971677499-5467cbab01c0?crop=entropy&cs=srgb&fm=jpg&q=85&w=600',
    },
    {
      name: 'General Contractors',
      description: 'Full home renovation and construction project leads.',
      image: 'https://images.unsplash.com/photo-1725462294312-d10464f66c2b?crop=entropy&cs=srgb&fm=jpg&q=85&w=600',
    },
  ];

  return (
    <section className="py-20 md:py-32 bg-[#f8fafc]" data-testid="industries-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <p className="text-sm tracking-wide uppercase font-semibold text-[#2563eb] mb-4">
            Industries We Serve
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#0f172a] tracking-tight mb-6">
            Appointment Generation for Home Service Contractors
          </h2>
          <p className="text-lg text-[#64748b] leading-relaxed">
            We specialize in connecting contractors with high-intent homeowners across all major home improvement categories.
          </p>
        </div>

        {/* Bento Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {industries.map((industry, index) => (
            <Link
              key={industry.name}
              to="/services"
              data-testid={`industry-card-${index}`}
              className={`industry-card group ${
                index === 0 || index === 5 ? 'md:col-span-2 lg:col-span-2' : ''
              } ${index === 0 || index === 5 ? 'h-80' : 'h-64'}`}
            >
              <img
                src={industry.image}
                alt={industry.name}
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0f172a]/90 via-[#0f172a]/40 to-transparent z-10" />
              <div className="absolute bottom-0 left-0 right-0 p-6 z-20">
                <div className="flex items-start justify-between">
                  <div>
                    <h3 className="text-xl font-bold text-white mb-2">{industry.name}</h3>
                    <p className="text-sm text-white/80">{industry.description}</p>
                  </div>
                  <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <ArrowUpRight className="w-5 h-5 text-white" />
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <p className="text-[#64748b] mb-4">Don't see your industry?</p>
          <Link 
            to="/contact" 
            className="text-[#2563eb] font-semibold hover:underline inline-flex items-center gap-2"
            data-testid="industries-contact-link"
          >
            Contact us to discuss your needs
            <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
};
